export default __webpack_public_path__ + "static/media/1933.1a6f83a5.png";